/**
 * True when a DevExtreme `byKey` key has no value.
 *
 * Select boxes call `store.byKey(value)` to show the label of the current
 * value, also when the value is empty. Loading `/resource/${key}` with an
 * empty key produces `/resource/`, which BadEndpointInterceptor blocks and
 * reports to Sentry (SNT-12451): `byKey` must return `undefined` instead.
 */
export function isEmptyKey(key: unknown): key is null | undefined | "" {
  return (
    key === null ||
    key === undefined ||
    (typeof key === "string" && key.trim() === "")
  );
}
